import { UserProps } from '@/entities/user'
import { api } from '@/lib/axios'
import axios from 'axios'

const loc = 'utils/upload-util'

export const uploadFile = (file: File, user: UserProps, key?: string): Promise<string | void> => {
  return new Promise(async (resolve, reject) => {
    try {
      const responsePresignedUrl = await api.post('/generate-presigned-url', {
        userRef: user?.ref,
        fileName: file.name,
        fileType: file.type,
        key
      })

      const { presignedURL, uploadURL } = responsePresignedUrl.data.body[0]

      await axios.put(presignedURL, file, {
        headers: {
          'Content-Type': file.type,
          'x-amz-server-side-encryption': 'AES256'
        }
      })

      resolve(uploadURL)
    } catch (err) {
      console.error(`Unhandled rejection at ${loc}._uploadFile function. Details: ${err}`)
      reject()
    } finally {
      resolve()
    }
  })
}
